<div class="">
  <table class="table table-bordered">
    <thead>
      <tr>
        <th width="1%" scope="col"></th>
        <th scope="col" translate>ITEM_NUMBER</th>
        <th scope="col" translate>NAME</th>
        <th *ngIf="!hidePrices" scope="col" translate>PRICE</th>
        <th scope="col" translate>COLOR_SIZE</th>
        <th scope="col" class="text-center" translate>PACKAGE_SIZE</th>
        @if (isCustomerService) {
          <th scope="col" class="text-center" translate>MOQ</th>
        }
        <th *ngIf="!hideAvailabilities" scope="col" translate>AVAILABILITY</th>
        <th width="150px" scope="col"></th>
      </tr>
    </thead>
    <tbody>
      @for (product of mappedData; track product.id; let idx = $index, e = $even) {
        <tr>
          <th scope="row">
            @if (!!product.extra.images && !!product.extra.images[0]) {
              <img
                loading="lazy"
                class="img-fluid"
                [src]="
                  product.extra.images[0].s3Uri | gungImageUrl: 'type:list' : 'etag:' + product.extra.images[0].s3ETag : 'size:300x300'
                "
                alt=""
              />
            }
          </th>
          <td>
            <a class="product-link" routerLink="/product/{{ product.id }}">
              {{ product.id }}
              @if (!!currentCustomer && currentCustomer.extra.kuarMapped?.[product.id]?.artbeskr2) {
                <span class="d-block">({{ currentCustomer.extra.kuarMapped[product.id]?.artbeskr2 }})</span>
              }
              @if (currentCustomer?.extra?.kuarMapped?.[product.id]?.artnrkund) {
                <span class="d-block">({{ currentCustomer?.extra?.kuarMapped?.[product.id]?.artnrkund }})</span>
              }
            </a>
          </td>
          <td>
            <a class="product-link" routerLink="/product/{{ product.id }}">
              @if (product.extra.i18n[currentLang].artbeskrspec) {
                @if (isSales) {
                  @if (product.extra.i18n[currentLang].artbeskr) {
                    {{ product.extra.i18n[currentLang].artbeskr }}
                  } @else {
                    {{ product.extra.ar.artbeskr }}
                  }
                  <br />
                }
                {{ product.extra.i18n[currentLang].artbeskrspec }}
              } @else if (product.extra.ar.artbeskrspec) {
                @if (isSales) {
                  {{ product.extra.ar.artbeskr }}<br />
                }
                {{ product.extra.ar.artbeskrspec }}
              } @else {
                {{ product.extra.ar.artbeskr }}
              }
            </a>
          </td>
          <td *ngIf="!hidePrices">
            <b>
              @if (displayStaffedPrices && product.price) {
                <span>
                  <hl-display-price [price]="product.price" displayOnlyPrice="true" type="STAFFED" [currentQty]="product.extra.minimumOrderQuantity"/>
                </span>
              } @else {
                <span *ngIf="product.price">
                  {{
                    product.price.customerGrossPrice.value
                      | gungCurrency: product.price.customerGrossPrice.currencyCode : 'symbol-narrow' : '1.2-2' : 'sv_SE'
                  }}
              </span>
                @if (displayDiscountFromPriceList && product.price?.backendPrice?.levels?.[0]?.extra?.prl?.proc1 > 0) {
                  <span class="text-disc">(-{{ product.price.backendPrice.levels[0].extra.prl.proc1 }}%)</span>
                }
              }
            </b>
            <span> {{ getAssortmentType(product.extra) }}</span>
          </td>
          <td>
            {{ hlDisplayMetadataHelperService.getProductColours(product) }}
            @if (hlDisplayMetadataHelperService.getProductColours(product) != '' && productSize[product.id] != '') {
              <br />
            }
            {{ productSize[product.id] }}
          </td>
          <td class="text-center">
            {{ product.extra.stepAmount | number: '1.0-2' }}
          </td>
          @if (isCustomerService) {
            <td class="text-center">
              {{ product.extra.minimumOrderQuantity | number: '1.0-2' }}
            </td>
          }
          <td *ngIf="!hideAvailabilities">
            <div class="d-flex align-items-center">
              <!-- {{product.extra.availabilities | json}} -->

              <app-hl-display-availability [availability]="product.availability"></app-hl-display-availability>

              <!-- @if (
                (
                  product.extra.availabilities['0'] ||
                  product.extra.availabilities['*'] ||
                  (stockId && product.extra.availabilities[stockId])
                ).currentAvailability > 0
              ) {
                <i class="fa-solid fa-circle fa-1x text-success"></i>
                <span class="ml-2" translate>AVAILABLE</span>
              } @else {
                <i class="fa-solid fa-circle fa-1x text-warning"></i>
                <span class="ml-2" translate>MADE_TO_ORDER</span>
              } -->
            </div>
          </td>
          <td>
            <div class="d-flex flex-column">
              <div class="d-flex flex-wrap mb-2 icon-row">
                <app-hl-display-favourite-product-icon class="product-info-icon" [id]="product.id"></app-hl-display-favourite-product-icon>
                @if (product.extra?.hlVideos?.[0]?.videoUrl) {
                  <a class="product-info-icon" [href]="product.extra.hlVideos[0].videoUrl" target="_blank" [title]="'VIDEO' | translate">
                    <i class="fa-regular fa-circle-play"></i>
                  </a>
                } @else {
                  <span class="product-info-icon disabled">
                    <i class="fa-regular fa-circle-play"></i>
                  </span>
                }
                @if (product.extra?.documents?.[0]) {
                  <a class="product-info-icon" [href]="product.extra.documents[0] | gungDownloadUrl" target="_blank" [title]="'DOCUMENT' | translate">
                    <i class="fa-regular fa-file-lines"></i>
                  </a>
                } @else {
                  <span class="product-info-icon disabled">
                    <i class="fa-regular fa-file-lines"></i>
                  </span>
                }
              </div>
              <app-hl-display-buy-btn class="w-100" [product]="product" [id]="product.id" [price]="product.price" />
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
